import React from 'react';
import SuggestionBlock from './SuggestionBlock';

export default function ChordsHint() {
    return <SuggestionBlock title='Черными точками обозначены заглушаемые струны'>
        Другими словами, в обозначениях аккордов и в табулатурах на этих струнах лежат пальцы, а звучат струны, отмеченные красными точками
    </SuggestionBlock>
}
